import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  API_URL
} from "../config/api";

import sanitizeRichHtml from
  "../utils/sanitizeRichHtml";

function AboutUs() {

    const [aboutUs, setAboutUs] = useState({
        content: "",
        editorialTeam: [],
        pastEditors: []
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const fetchAboutUs = async () => {

            try {

                const res = await axios.get(
                    `${API_URL}/api/about-us`
                );

                setAboutUs(res.data);

            } catch (error) {

                console.error(
                    "Error loading About Us:",
                    error
                );

            } finally {

                setLoading(false);

            }

        };

        fetchAboutUs();

    }, []);


    if (loading) {

        return (

            <main
                style={{
                    maxWidth: "1000px",
                    margin: "40px auto",
                    padding: "20px"
                }}
            >

                <p>Loading About Us...</p>

            </main>

        );

    }


    const editorialTeam =
        [...(aboutUs.editorialTeam || [])]
            .sort(
                (a, b) =>
                    (a.order ?? 0) -
                    (b.order ?? 0)
            );


    const pastEditors =
        [...(aboutUs.pastEditors || [])]
            .sort(
                (a, b) =>
                    (a.order ?? 0) -
                    (b.order ?? 0)
            );


    return (

        <main
            style={{
                maxWidth: "1000px",
                margin: "40px auto",
                padding: "20px"
            }}
        >

            {/* ========================= */}
            {/* ABOUT US */}
            {/* ========================= */}

            <section>

                <h1
                    style={{
                        marginBottom: "25px"
                    }}
                >
                    About Us
                </h1>


                {aboutUs.content ? (

                    <div
                        style={{
                            lineHeight: "1.8",
                            fontSize: "17px"
                        }}
                        dangerouslySetInnerHTML={{
    __html:
        sanitizeRichHtml(
            aboutUs.content
        )
}}
                    />

                ) : (

                    <p>
                        No About Us information
                        available yet.
                    </p>

                )}

            </section>


            {/* ========================= */}
            {/* EDITORIAL TEAM */}
            {/* ========================= */}

            <section
                style={{
                    marginTop: "50px"
                }}
            >

                <h2
                    style={{
                        marginBottom: "20px"
                    }}
                >
                    Editorial Team
                </h2>


                {editorialTeam.length > 0 ? (

                    <ol
                        style={{
                            paddingLeft: "25px"
                        }}
                    >

                        {editorialTeam.map(
                            (member) => (

                                <li
                                    key={member._id}
                                    style={{
                                        marginBottom:
                                            "10px",
                                        fontSize:
                                            "17px"
                                    }}
                                >
                                    {member.name}
                                </li>

                            )
                        )}

                    </ol>

                ) : (

                    <p>
                        No editorial team
                        information available.
                    </p>

                )}

            </section>


            {/* ========================= */}
            {/* PAST EDITORS */}
            {/* ========================= */}

            <section
                style={{
                    marginTop: "50px"
                }}
            >

                <h2
                    style={{
                        marginBottom: "20px"
                    }}
                >
                    Past Editors
                </h2>


                {pastEditors.length > 0 ? (

                    <ol
                        style={{
                            paddingLeft: "25px"
                        }}
                    >

                        {pastEditors.map(
                            (member) => (

                                <li
                                    key={member._id}
                                    style={{
                                        marginBottom:
                                            "10px",
                                        fontSize:
                                            "17px"
                                    }}
                                >
                                    {member.name}
                                </li>

                            )
                        )}

                    </ol>

                ) : (

                    <p>
                        No past editors
                        information available.
                    </p>

                )}

            </section>

        </main>

    );

}

export default AboutUs;